export function sharedUtilsServices(): string {
  return 'shared-utils-services';
}
